// Mock data for ET Bienes Raíces Digital Landing Page

export const companyInfo = {
  name: "ET",
  tagline: "Bienes Raíces Digital",
  slogan: "Tu hogar ideal en Piura",
  description: "Somos una empresa inmobiliaria comprometida con ayudarte a encontrar la propiedad perfecta para ti y tu familia en Piura.",
  phone1: "915217831",
  phone2: "",
  whatsapp: "51915217831",
  email: "contacto@etbienesraices.pe",
  address: "Piura, Perú",
  logo: "/images/logo-et.png"
};

export const properties = [
  {
    id: 1,
    title: "Departamentos en Residencial Arena",
    type: "Preventa",
    location: "Urb. Laguna del Chipe, Piura",
    price: 299500,
    priceDollar: 89136,
    currency: "S/.",
    area: 65,
    bedrooms: 2,
    bathrooms: 2,
    parking: 3,
    deliveryDate: "Mayo 2026",
    images: [
      "https://images.unsplash.com/photo-1706808849827-7366c098b317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjE4NDYxNnww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1612965607446-25e1332775ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxsaXZpbmclMjByb29tJTIwbHV4dXJ5JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2MTg0NjE2fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjE4NDYxNnww&ixlib=rb-4.1.0&q=85"
    ],
    featured: true,
    description: "Proyecto en construcción con fecha de entrega para Mayo 2026. Ubicado en exclusiva zona de Urb. Laguna del Chipe - Piura.",
    highlights: [
      "Edificio exclusivo de solo 8 departamentos en 4 pisos + azotea",
      "Ascensor incluido",
      "Azotea con zona de parrilla y co-working de uso común",
      "Pet Spa en el 1er nivel",
      "Cocina equipada de regalo (encimera, horno y campana extractora)",
      "Aire acondicionado en dormitorio principal"
    ],
    features: [
      "Sala-comedor",
      "Cocina equipada",
      "2 Dormitorios (principal con baño propio)",
      "Zona de lavandería en azotea",
      "Depósito independiente",
      "Intercomunicador y video portero"
    ],
    finishes: [
      "Piso SPC en sala-comedor y dormitorios",
      "Porcelanato en cocina y baños",
      "Tablero de piedra sintetizada o cuarzo",
      "Muebles de Melamina Pelikano",
      "Sanitarios y grifería Vainsa o Trébol línea premium"
    ],
    nearbyPlaces: ["UDEP", "UPAO", "Turicará", "Innova School Ejidos", "Centros Comerciales"],
    parkingPrice: 19500,
    bonoMiVivienda: true
  },
  {
    id: 2,
    title: "Casa Dúplex en Casuarinas",
    type: "Estreno",
    location: "Urbanización Casuarinas 1° etapa, Piura",
    price: 495000,
    currency: "S/.",
    area: 120,
    bedrooms: 4,
    bathrooms: 5,
    parking: 1,
    images: [
      "https://images.unsplash.com/photo-1706808849802-8f876ade0d1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjE4NDYxNnww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1612965607446-25e1332775ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxsaXZpbmclMjByb29tJTIwbHV4dXJ5JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2MTg0NjE2fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1706808849827-7366c098b317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjE4NDYxNnww&ixlib=rb-4.1.0&q=85"
    ],
    featured: true,
    description: "Hermoso Dúplex de estreno dentro de un condominio seguro. Descubre la comodidad y el espacio que tu familia merece.",
    distribution: {
      "1er Piso": [
        "Sala comedor",
        "Baño de visita",
        "Cocina con reposteros altos y bajos",
        "Patio",
        "Cochera"
      ],
      "2do Piso": [
        "Salita de estar",
        "Habitación principal con walk-in closet y baño incorporado",
        "Habitación secundaria con closet y baño compartido"
      ],
      "3er Piso": [
        "1 habitación secundaria con closet y baño completo",
        "Área de servicio con habitación y baño",
        "Lavandería",
        "Terraza con terma al aire libre",
        "Zona de parrilla y mesa con baño para invitados"
      ]
    },
    highlights: [
      "Dentro de condominio seguro",
      "Walk-in closet en habitación principal",
      "Terraza con zona de parrilla",
      "Área de servicio completa",
      "Excelente vista dentro del condominio"
    ],
    nearbyPlaces: ["UDEP", "UPAO", "Vallesol", "Turicará", "Innova Schools"]
  }
];

export const services = [
  {
    id: 1,
    title: "Asesoría Gratuita",
    description: "Te brindamos asesoría gratuita para que puedas obtener tu crédito hipotecario y el Bono Mi Vivienda.",
    icon: "FileCheck"
  },
  {
    id: 2,
    title: "Propiedades Exclusivas",
    description: "Acceso a las mejores propiedades en zonas de alta plusvalía en Piura.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Inversión Segura",
    description: "Te ayudamos a realizar una inversión segura con propiedades que garantizan excelente valorización.",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Atención Personalizada",
    description: "Acompañamiento en todo el proceso de compra, desde la visita hasta la firma de escrituras.",
    icon: "Users"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María García",
    text: "Excelente atención y asesoría. Encontré mi departamento ideal gracias a ET Bienes Raíces Digital.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    text: "Muy profesionales. Me ayudaron con todo el proceso del crédito hipotecario.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana López",
    text: "Recomiendo ET Bienes Raíces Digital. La inversión que hice hace 2 años ya se valorizó significativamente.",
    rating: 5
  }
];

export const stats = [
  { value: "50+", label: "Propiedades Vendidas" },
  { value: "100%", label: "Clientes Satisfechos" },
  { value: "5+", label: "Años de Experiencia" },
  { value: "24/7", label: "Atención al Cliente" }
];
